import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { useEntryFormContext } from 'context/EntryFormContext';
import { SUBSCRIPTION_TYPES } from 'constants/subsctiptionTypes';
import { Input } from 'components/Input';
import styles from 'pages/Schedule/CreateEntry/CreateEntry.scss';

export const GroupInput = () => {
  const { form, entryTypeIndex, currentLocationGroups } = useEntryFormContext();

  const handleGroupChange = ({ target: { value } }) => {
    const fullGroup = currentLocationGroups.find(({ name }) => name === value);

    if (fullGroup) {
      form.setFieldValue('group', fullGroup.name);

      const groupClients = fullGroup.members.map(({ name, surname, subscriptions }) => ({
        fullName: `${surname} ${name}`,
        price: '',
        locked: true,
        subscription: subscriptions.find(
          (sub) =>
            sub.status === 'active' &&
            (sub.type === SUBSCRIPTION_TYPES.SUBSCRIPTION || sub.type === SUBSCRIPTION_TYPES.MEMBERSHIP)
        ),
      }));

      form.setFieldValue('clients', groupClients);
    } else {
      form.setFieldValue('group', value);
      form.setFieldValue('clients', [{ client: '', price: '', locked: false }]);
    }
  };

  if (entryTypeIndex === 0) {
    return null;
  }

  return (
    <Input
      className={styles.groupInput}
      value={form.values.group}
      name='group'
      placeholder='Введіть групу'
      icon={faUsers}
      onChange={handleGroupChange}
      suggestions={currentLocationGroups.map((g) => g.name)}
    />
  );
};
